import api from './api';

export const sliderPublicService = {
    getSliders: async () => {
        try {
            const response = await api.get('/sliders');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data slider'
            };
        }
    },
};

export default sliderPublicService;